import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from "axios";
import { Link, navigate } from 'raviger';
import Moment from 'react-moment';
import Select, { components, createFilter } from 'react-select';
import { Carousel } from 'react-responsive-carousel';
import RangeSlider from 'react-bootstrap-range-slider';
import { Button, Card, Col, ListGroup, Modal, OverlayTrigger, Row, Tooltip, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBan, faGlobe, faMedkit, faCut, faEdit, faEnvelope, faLink, faMinusSquare, faTimes, faUserPlus, faFilePdf,
  faReply,
  faPaw
} from '@fortawesome/free-solid-svg-icons';
import { faHandsHolding, faUserDoctorMessage, faClawMarks, faFolderMedical, faHomeHeart, faPhonePlus, faRightLeft, faSplit, faSkullCrossbones } from '@fortawesome/pro-solid-svg-icons';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import MaterialRadio from '@mui/material/Radio';
import { makeStyles } from '@mui/styles';
import * as Yup from 'yup';
import { Formik } from "formik";
import Scrollbar from '../components/Scrollbars';
import { AnimalDeleteModal } from "../components/Modals";
import Header from '../components/Header';
import History from '../components/History';
import { Checkbox, DateTimePicker, DropDown, TextInput } from '../components/Form.js';
import { printAnimalCareSchedule } from './Utils';
import AnimalCoverImage from '../components/AnimalCoverImage';
import { SystemErrorContext } from '../components/SystemError';
import ShelterlyPrintifyButton from '../components/ShelterlyPrintifyButton';
import { useLocationWithRoutes } from '../hooks';
import LoadingLink from '../components/LoadingLink';
import { AuthContext } from "../accounts/AccountsReducer";
import ActionsDropdown from '../components/ActionsDropdown';
import { isImageFile } from '../utils/files';

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    color: 'white',
  },
  radio: {
    color: 'inherit',
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: '#DFDDDD',
      cursor: 'not-allowed',
      pointerEvents: 'all !important',
      title: 'test'
    },
  },
  checkedIcon: {
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: '#106ba3',
    },
  },
});

const customStyles = {
  // For the select it self, not the options of the select
  control: (styles, { isDisabled}) => {
    return {
      ...styles,
      color: '#FFF',
      cursor: isDisabled ? 'not-allowed' : 'default',
      backgroundColor: isDisabled ? '#DFDDDD' : 'white',
      height: 35,
      minHeight: 35
    }
  },
  option: provided => ({
    ...provided,
    color: 'black'
  }),
  singleValue: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? '#595959' : 'black'
  }),
};

function AnimalDetails({ id, incident, organization }) {
  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);
  const [images, setImages] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const classes = useStyles();

  // Initial animal data.
  const [data, setData] = useState({
    id: null,
    id_for_incident: '',
    owners: [],
    request: null,
    request_id_for_incident: '',
    name: '',
    species_string: '',
    species_string_singular: '',
    sex: '',
    size: '',
    age: '',
    pcolor: '',
    scolor: '',
    color_notes: '',
    fixed: 'unknown',
    aggressive: 'unknown',
    aco_required: 'unknown',
    confined: 'unknown',
    injured: 'unknown',
    behavior_notes: '',
    medical_notes: '',
    microchip: '',
    intake_date: null,
    front_image: null,
    side_image: null,
    room: null,
    owner_contacts: [],
    vet_requests: [],
    extra_images: [],
    action_history: [],
    public: false,
    pll_metadata: {},
    shelter_object: {name: '', full_address: ''}
  });

  const [noteData, setNoteData] = useState({'id': null, 'owner':null, 'owner_contact_time': new Date(), 'owner_contact_note': ''})
  const [selectedAddress, setSelectedAddress] = useState({address:'', string:''});
  const [publicShow, setPublicShow] = useState(false);
  const handlePublicClose = () => setPublicShow(false);
  const [pllShow, setPLLShow] = useState(false);
  const handlePLLClose = () => setPLLShow(false);
  const [showChangeAnimalStatus, setShowChangeAnimalStatus] = useState(false);
  const handleShowChangeAnimalStatusClose = () => {setStatusChange('');setShowChangeAnimalStatus(false)};
  const [showSplit, setShowSplit] = useState(false);
  const handleCloseSplit = () => setShowSplit(false);
  const [showTransfer, setShowTransfer] = useState(false);
  const handleCloseTransfer = () => setShowTransfer(false);
  const [showContactNote, setShowContactNote] = useState(false);
  const handleCloseContactNote = () => setShowContactNote(false);
  const [ownerToDelete, setOwnerToDelete] = useState({id:0, name:''});
  const [showOwnerConfirm, setShowOwnerConfirm] = useState(false);
  const handleOwnerClose = () => setShowOwnerConfirm(false);
  const [showAnimalConfirm, setShowAnimalConfirm] = useState(false);
  const handleAnimalClose = () => setShowAnimalConfirm(false);
  const { getFullLocationFromPath } = useLocationWithRoutes();
  const [shelters, setShelters] = useState({options: [], shelters: [], room_options: {}, isFetching: false});
  const [species, setSpecies] = useState([]);
  const [statusChange, setStatusChange] = useState('');
  const [changeStatusOptions, setChangeStatusOptions] = useState([]);

  const roomRef = useRef(null);

  // Handle basic status change.
  const handleStatusChange = async () => {
    setIsLoading(true);
    await axios.patch('/animals/api/animal/' + data.id + '/', {status:statusChange})
    .then(response => {
      setData(prevState => ({ ...prevState, status:statusChange }));
      handleChangeOptions(response.data);
      handleShowChangeAnimalStatusClose();
      setStatusChange('');
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  // Handle animal reunited submit.
  const handleReuniteSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/animals/api/animal/' + data.id + '/', {status:'REUNITED', shelter:null, room:null})
    .then(response => {
      setData(prevState => ({ ...prevState, status:'REUNITED', shelter:null, room:null }));
      handleChangeOptions(response.data);
      handleShowChangeAnimalStatusClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  // Handle animal return requested submit.
  const handleReturnRequestedSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/hotline/api/servicerequests/' + data.request + '/', {return_animals:[data.id]})
    .then(response => {
      setData(prevState => ({ ...prevState, "status":"RETURN REQUESTED" }));
      handleChangeOptions(response.data);
      handleShowChangeAnimalStatusClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  // Handle animal public submit.
  const handlePublicSubmit = async () => {
    setIsLoading(true);
    let newPublicState = !data.public
    await axios.patch('/animals/api/animal/' + data.id + '/', {public:newPublicState})
    .then(response => {
      setData(prevState => ({ ...prevState, public:newPublicState }));
      handlePublicClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  // Handle animal public submit.
  const handlePLLSubmit = async () => {
    setIsLoading(true);
    let newPLLState = !data.pll_metadata
    await axios.patch('/animals/api/animal/' + data.id + '/', {pll_send:newPLLState})
    .then(response => {
      setData(prevState => ({ ...prevState, pll_metadata:response.data.pll_metadata }));
      handlePLLClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  // Handle animal deceased submit.
  const handleDeceasedSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/animals/api/animal/' + data.id + '/', {status:'DECEASED', shelter:null, room:null})
    .then(response => {
      setData(prevState => ({ ...prevState, status:'DECEASED', shelter:null, room:null }));
      handleChangeOptions(response.data);
      handleShowChangeAnimalStatusClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  // Handle remove owner submit.
  const handleOwnerSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/animals/api/animal/' + data.id + '/', {remove_owner:ownerToDelete.id})
    .then(response => {
      setData(prevState => ({ ...prevState, "owners":prevState.owners.filter(owner => owner.id !== ownerToDelete.id) }));
      handleOwnerClose();
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  // Handle animal removal submit.
  const handleAnimalSubmit = async () => {
    setIsLoading(true);
    await axios.patch('/animals/api/animal/' + data.id + '/', {remove_animal:data.id})
    .then(response => {
      handleAnimalClose();
      if (data.request) {
        navigate('/' + organization + '/' + incident + '/hotline/servicerequest/' + data.request_id_for_incident);
      }
      else if (data.owner) {
        navigate('/' + organization + '/' + incident + '/people/owner/' + data.owner);
      }
      else if (data.reporter) {
        navigate('/' + organization + '/' + incident + '/people/reporter/' + data.reporter);
      }
      else {
        navigate('/' + organization + '/' + incident);
      }
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  const handleDownloadPdfClick = async () => {
    setIsLoading(true);
    const pageURL = getFullLocationFromPath(`/${organization}/${incident}/animals/${data.id_for_incident}`);
    // wait for 1 tick so spinner will set before the print button locks up the browser
    await new Promise(resolve => setTimeout(resolve, 0));
    printAnimalCareSchedule({ ...data, url: pageURL })
      .finally(() => setIsLoading(false));
  }

  const handleChangeOptions = (data) => {
    let status_change_options = [];
    let reported_status = [{value:'REPORTED', label:'Reported'}, {value:'REPORTED (EVAC REQUESTED)', label:"Reported (Evac Requested)"}, {value:'REPORTED (SIP REQUESTED)', label:'Reported (SIP Requested)'}];
    if (data.status.includes('REPORTED')) {
      status_change_options.push(...reported_status.filter(status => status.value !== data.status));
    }
    if (!['REUNITED', 'DECEASED'].includes(data.status)) {
      status_change_options.push({value:'reunited', label:'Reunited'});
      status_change_options.push({value:'deceased', label:'Deceased'});
    }
    if (['REUNITED', 'SHELTERED'].includes(data.status) || data.status.includes('REPORTED')) {
      status_change_options.push({value:'return_requested', label:'Return Requested'});
    }
    setChangeStatusOptions(status_change_options);
  }

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();
    setIsLoading(true);
    const fetchAnimalData = async () => {
      // Fetch Animal data.
      await axios.get('/animals/api/incident/' + (state ? state.incident.id : 'undefined') + '/animal/' + id + '/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setData(response.data);
          handleChangeOptions(response.data);
          let image_urls = [];
          image_urls = image_urls.concat(response.data.front_image||[]).concat(response.data.side_image||[]);
          const photoDocuments = response.data.extra_images;
          if (Array.isArray(photoDocuments)) {
            const extraImages = [];
            const extraDocuments = [];
            photoDocuments.forEach((photoDocument) => {
              if (isImageFile(photoDocument)) {
                extraImages.push(photoDocument);
              } else {
                extraDocuments.push(photoDocument);
              }
            });
            image_urls = image_urls.concat(extraImages);
            setDocuments(extraDocuments);
          }
          setImages(image_urls);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      })
      .finally(() => setIsLoading(false));
    };
    fetchAnimalData();

    const fetchShelters = () => {
      setShelters({options: [], shelters: [], room_options: {}, isFetching: true});
      // Fetch Shelter data.
      axios.get('/shelter/api/shelter/?incident=' + incident + '&organization=' + organization, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let options = [];
          let room_options = {};
          response.data.forEach(shelter => {
            // Build shelter option list.
            options.push({value: shelter.id, label: shelter.name});
            room_options[shelter.id] = [];
            shelter.buildings.forEach(building => {
              building.rooms.forEach(room => {
                // Build room option list identified by shelter ID.
                room_options[shelter.id].push({value: room.id, label: room.building_name + ' - ' + room.name + ' (' + (room.animal_count || 0) + ' animals)'});
              });
            });
          });
          setShelters({options: options, shelters:response.data, room_options:room_options, isFetching:false});
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShelters({options: [], shelters: [], room_options: {}, isFetching: false});
          setShowSystemError(true);
        }
      });
    };
    fetchShelters();

    const fetchSpecies = () => {
      // Fetch Species data.
      axios.get('/animals/api/species/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setSpecies(response.data);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };
    fetchSpecies();

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [id]);

  return (
    <>
    <Header>{`Animal #${data.id_for_incident || ' - '}`}</Header>
    <div className="row gx-3 me-0">
      <div className="col-6 d-flex" style={{marginRight:"0px"}}>
        <Card className="border rounded w-100">
          <Card.Body style={{marginTop:"-10px", marginBottom:"-6px"}}>
            <div className="d-flex justify-content-between">
              <h4 style={{paddingTop:"5px"}}>Information
              {data.confined === 'yes' ?
                <OverlayTrigger
                  key={"confined"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-confined`}>
                      Animal is confined
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faLink} size="sm" className="ms-1 fa-move-up" transform={'shrink-2'} />
                </OverlayTrigger> :
              ""}
              {data.aggressive === 'yes' ?
                <OverlayTrigger
                  key={"aggressive"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-aggressive`}>
                      Animal is aggressive
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faClawMarks} size="sm" className="ms-1" />
                </OverlayTrigger> :
              data.aggressive === 'no' ?
                <OverlayTrigger
                  key={"not-aggressive"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-aggressive`}>
                      Animal is not aggressive
                    </Tooltip>
                  }
                >
                  <span className="fa-layers" style={{marginLeft:"2px"}}>
                    <FontAwesomeIcon icon={faClawMarks} size="sm" />
                    <FontAwesomeIcon icon={faBan} color="#ef5151" size="sm" transform={'shrink-2'} />
                  </span>
                </OverlayTrigger> :
              ""}
              {data.aco_required === 'yes' ?
                <OverlayTrigger
                  key={"aco-required"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-aco-required`}>
                      Special Handling Required
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faHandsHolding} size="sm" className="ms-1" />
                </OverlayTrigger> : ""}
              {data.injured === 'yes' ?
                <OverlayTrigger
                  key={"injured"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-injured`}>
                      Animal is injured
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faMedkit} size="sm" className="ms-1 fa-move-up" />
                </OverlayTrigger> :
              data.injured === 'no' ?
                <OverlayTrigger
                  key={"not-injured"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-injured`}>
                      Animal is not injured
                    </Tooltip>
                  }
                >
                  <span className="fa-layers" style={{marginLeft:"2px"}}>
                    <FontAwesomeIcon icon={faMedkit} size="sm" className="fa-move-up" />
                    <FontAwesomeIcon icon={faBan} color="#ef5151" size="sm" transform={'shrink-2'} />
                  </span>
                </OverlayTrigger> :
              ""}
              {data.fixed === 'yes' ?
                <OverlayTrigger
                  key={"fixed"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-fixed`}>
                      Animal is fixed or neutered
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faCut} size="sm" className="ms-1" />
                </OverlayTrigger> :
              data.fixed === 'no' ?
              <OverlayTrigger
                key={"not-fixed"}
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-fixed`}>
                    Animal is not fixed or neutered
                  </Tooltip>
                }
              >
                <span className="fa-layers" style={{marginLeft:"2px"}}>
                  <FontAwesomeIcon icon={faCut} size="sm" />
                  <FontAwesomeIcon icon={faBan} color="#ef5151" size="sm" transform={'shrink-2'} />
                </span>
              </OverlayTrigger> :
              ""}
              {data.public === true ?
                <OverlayTrigger
                  key={"public"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-public`}>
                      Animal is public
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faGlobe} size="sm" className="ms-1 fa-move-up" transform={'shrink-2'} />
                </OverlayTrigger> : ""}
              </h4>
              {isLoading ? (
                <Spinner
                  className="align-self-center me-3"
                  {...{
                    as: 'span',
                    animation: 'border',
                    size: undefined,
                    role: 'status',
                    'aria-hidden': 'true',
                    variant: 'light',
                    style: {
                      height: '1.5rem',
                      width: '1.5rem',
                      marginBottom: '0.75rem'
                    }
                  }}
                />
              ) : (
                <ActionsDropdown variant="secondary" title="Actions">
                  <LoadingLink
                    href={"/" + organization + "/" + incident + "/animals/edit/" + id}
                    isLoading={isLoading}
                    className="d-block"
                    label="Update Animal"
                  >
                    <FontAwesomeIcon icon={faEdit} className="fas" inverse />
                  </LoadingLink>
                  <ShelterlyPrintifyButton
                    id="animal-details-animal-care-schedule"
                    spinnerSize={2.0}
                    tooltipPlacement='right'
                    label='Download Animal Care Schedule'
                    printFunc={handleDownloadPdfClick}
                    disabled={isLoading}
                    noOverlay={true}
                  />
                  <LoadingLink onClick={() => setShowChangeAnimalStatus(true)} label="Change Animal Status" disabled={changeStatusOptions.length === 0} disabled_text="No status options currently available." isLoading={isLoading} className="d-block">
                    <FontAwesomeIcon icon={faPaw} className="fas" style={{cursor:'pointer'}} inverse />
                  </LoadingLink>
                  <LoadingLink disabled={!(data.animal_count > 1 && !data.medical_record)} disabled_text="Individual animals may not be split." onClick={() => setShowSplit(true)} isLoading={isLoading} className="d-block" label="Split Animal Group">
                    <FontAwesomeIcon icon={faSplit} className="fas" inverse />
                  </LoadingLink>
                  <LoadingLink
                    href={"/" + organization + "/" + incident + "/animals/" + id + "/vetrequest/new"}
                    disabled={data.animal_count > 1 || ['REUNITED', 'DECEASED'].includes(data.status)}
                    disabled_text={data.animal_count > 1 ? "Veterinary requests may only be created for individual animals." : "Veterinary requests may not be created for Deceased or Reunited animals."}
                    isLoading={isLoading}
                    className="d-block"
                    label="Create Veterinary Request"
                  >
                    <FontAwesomeIcon icon={faUserDoctorMessage} className="fas" />
                  </LoadingLink>
                  {!data.public && (
                    <LoadingLink
                      onClick={() => setPublicShow(true)}
                      disabled={!['SHELTERED', 'RETURN REQUESTED', 'REUNITED', 'DECEASED'].includes(data.status)}
                      disabled_text="An animal may only be marked as public if it is Sheltered, Return Requested, Reunited, or Deceased."
                      isLoading={isLoading}
                      className="d-block"
                      label="Mark Animal Public"
                    >
                      <FontAwesomeIcon icon={faGlobe} className="fas" style={{ cursor: 'pointer' }} inverse />
                    </LoadingLink>
                  )}
                  {data.public && (
                    <LoadingLink
                      onClick={() => setPublicShow(true)}
                      isLoading={isLoading}
                      className="d-block"
                      label="Mark Animal Private"
                    >
                      <span className="fa-layers">
                        <FontAwesomeIcon icon={faGlobe} className="fas" />
                        <FontAwesomeIcon 
                          icon={faTimes} 
                          color="#ef5151" 
                          transform="grow-6"
                        />
                      </span>
                    </LoadingLink>
                  )}
                  {data.public === true && data.latitude && data.longitude && state.organization.beta_features && (
                    <LoadingLink
                      onClick={() => setPLLShow(true)}
                      isLoading={isLoading}
                      className="d-block"
                      label="Mark Animal Public on PLL"
                    >
                      <FontAwesomeIcon icon={faGlobe} className="fas" style={{ cursor: 'pointer' }} inverse />
                    </LoadingLink>
                  )}
                  {data.pll_metadata && (
                    <LoadingLink
                      onClick={() => setPLLShow(true)}
                      isLoading={isLoading}
                      className="d-block"
                      label="Mark Animal Private on PLL"
                    >
                        <span className="fa-layers">
                          <FontAwesomeIcon icon={faGlobe} className="fas" />
                          <FontAwesomeIcon 
                            icon={faBan} 
                            color="#ef5151" 
                            transform="grow-6"
                          />
                        </span>
                    </LoadingLink>
                  )}
                  <LoadingLink onClick={() => {setShowAnimalConfirm(true);}} isLoading={isLoading} className="d-block" label="Cancel Animal">
                    <FontAwesomeIcon icon={faBan} style={{cursor:'pointer'}} inverse />
                  </LoadingLink>
                </ActionsDropdown>
              )}
            </div>
            <p className="phr pt-0 mt-1" />
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
              <ListGroup.Item>
                <div className="row">
                  {data.animal_count > 1 ? <span className="col-6"><b>No. of Animals:</b> {data.animal_count}</span> : <span className="col-6"><b>Name:</b> {data.name||"Unknown Name"}</span>}
                  <span className="col-6" style={{textTransform:"capitalize"}}><b>Status:</b> {data.status}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item style={{textTransform:"capitalize"}}>
                <div className="row">
                  <span className="col-6"><b>Species:</b> {data.species_string_singular}</span>
                  <span className="col-6"><b>Sex:</b> {data.sex||"Unknown"}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item style={{textTransform:"capitalize"}}>
                <div className="row">
                  <span className="col-6"><b>Age:</b> {data.age||"Unknown"}</span>
                  <span className="col-6"><b>Size:</b> {data.size||"Unknown"}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item style={{textTransform:"capitalize"}}>
                <div className="row">
                  <span className="col-6"><b>Primary Color:</b> {data.pcolor||"N/A"}</span>
                  <span className="col-6"><b>Secondary Color:</b> {data.scolor||"N/A"}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row">
                  <span className="col-6"><b>Microchip:</b> {data.microchip || "N/A"}</span>
                  <span className="col-6"><b>External ID:</b> {data.external_id || "N/A"}</span>
                </div>
              </ListGroup.Item>
              {data.public && (
                <ListGroup.Item>
                  <b>Public Data:</b>{' '}
                  <Link
                    href={`/public?id=${data.id}`}
                    target="_blank"
                    className="text-link"
                    style={{ textDecoration: "none", color: "white" }}
                    rel="noopener noreferrer"
                  >
                    Public Record
                  </Link>
                  {data.pll_metadata?.imageSearch && (
                    <>
                      {' | '}
                      <Link
                        href={data.pll_metadata.imageSearch}
                        target="_blank"
                        className="text-link"
                        style={{ textDecoration: "none", color: "white" }}
                        rel="noopener noreferrer"
                      >
                        PLL Image Search
                      </Link>
                    </>
                  )}
                  {data.pll_metadata?.proximitySearch && (
                    <>
                      {' | '}
                      <Link
                        href={data.pll_metadata.proximitySearch}
                        target="_blank"
                        className="text-link"
                        style={{ textDecoration: "none", color: "white" }}
                        rel="noopener noreferrer"
                      >
                        PLL Proximity Search
                      </Link>
                    </>
                  )}
                </ListGroup.Item>
              )}
            </ListGroup>
            {/* {documents.length ? (
              <>
                <Card.Title>
                  <h4 className="mb-0 mt-3">Documents</h4>
                </Card.Title>
                <hr />
                <ListGroup variant="flush" style={{marginBottom:"-13px", marginTop:"-13px"}}>
                {documents.map((document) => (
                  <ListGroup.Item key={document}>
                    <a href={document} target="_blank" rel="noreferrer" className="d-flex flex-row align-items-start" style={{textDecoration:"none", color:"white"}}>
                      <FontAwesomeIcon icon={faFilePdf} inverse className="align-self-center" />
                      <span className="ms-2">{getFileNameFromUrl(document)}</span>
                    </a>
                  </ListGroup.Item>
                ))}
                </ListGroup>
              </>
            ) : null} */}
          </Card.Body>
        </Card>
      </div>
      <Col xs={6} className="pe-0 d-flex flex-column">
        <div className="slide-container flex-grow-1 border rounded ps-0 pe-0" style={{width:"auto", height:"345px"}}>
          {images.length < 1 ?
            <Carousel className="carousel-wrapper h-100" showThumbs={false} showStatus={false}>
              <AnimalCoverImage
                animalSpecies={data.species_string_singular}
                animalImageSrc={data.front_image}
                customStyles={{ width: '100%', padding: '40px', height:'343px', borderRadius: '3px' }}
              />
            </Carousel>
          :
            <Carousel className="carousel-wrapper" showThumbs={false} showStatus={false}>
              {images.map(image => (
                <div key={image} className="image-container">
                  <img src={image} alt="Animal" />
                </div>
              ))}
            </Carousel>
          }
        </div>
      </Col>
    </div>
    <div className="row gx-3 me-0" style={{marginBottom:"-15px"}}>
      <div className="col-6 d-flex mt-3">
        <Card className="border rounded d-flex mb-3" style={{width:"100%"}}>
          <Card.Body>
            <div className="d-flex justify-content-between" style={{marginBottom:"-8px", marginTop:"-10px"}}>
              <h4 style={{marginBottom:"-4px", marginTop:"3px"}}>Location</h4>
              {isLoading ? (
                <Spinner
                  className="align-self-center me-3"
                  {...{
                    as: 'span',
                    animation: 'border',
                    size: undefined,
                    role: 'status',
                    'aria-hidden': 'true',
                    variant: 'light',
                    style: {
                      height: '1.5rem',
                      width: '1.5rem',
                      marginBottom: '0.75rem'
                    }
                  }}
                />
              ) : (
                <ActionsDropdown variant="secondary" title="Actions">
                  <LoadingLink disabled={!data.shelter} disabled_text="Animal is not sheltered." onClick={() => setShowTransfer(true)} isLoading={isLoading} className="d-block" label="Transfer Animal Between Shelters">
                    <FontAwesomeIcon icon={faRightLeft} className="fas" style={{cursor:'pointer'}} inverse />
                  </LoadingLink>
                </ActionsDropdown>
              )}
            </div>
            <p className="phr"/>
            <ListGroup variant="flush" style={{marginBottom:"-13px", marginTop:"-13px"}}>
              <ListGroup.Item><b>Found Location: </b>{data.found_location || "N/A"}</ListGroup.Item>
              {data.request ?
                <ListGroup.Item><b>Service Request: </b><Link href={"/" + organization + "/" + incident + "/hotline/servicerequest/" + data.request_id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>{data.request_address}</Link></ListGroup.Item>
              : ''}
              {data.shelter && (
                <ListGroup.Item>
                  <Row>
                    <Col>
                      <b>Shelter:</b>{" "}
                      <Link
                        href={`/${organization}/${incident}/shelter/${data.shelter}`}
                        className="text-link"
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        {data.shelter_object?.name || "Unknown"}
                      </Link>
                    </Col>
                    <Col>
                      {data.room && (
                        <div>
                          <b>Room:</b>{" "}
                          <Link
                            href={`/${organization}/${incident}/shelter/room/${data.room}`}
                            className="text-link"
                            style={{ textDecoration: "none", color: "white" }}
                          >
                            {data.room_name || "Unknown"}
                          </Link>
                        </div>
                      )}
                    </Col>
                  </Row>

                  {data.intake_date && (
                    <div className="mt-1">
                      <b>Intake Date:</b>{" "}
                      {data.intake_summary ? (
                        <Link
                          href={`/${organization}/${incident}/shelter/intakesummary/${data.intake_summary.id}`}
                          className="text-link"
                          style={{ textDecoration: "none", color: "white" }}
                        >
                          <Moment format="MMMM Do YYYY HH:mm">{data.intake_date}</Moment>
                        </Link>
                      ) : (
                        <Moment format="MMMM Do YYYY HH:mm">{data.intake_date}</Moment>
                      )}
                    </div>
                  )}

                  <div className="mt-1">
                    <b>Address:</b> {data.shelter_object?.full_address || "Unknown"}
                  </div>
                </ListGroup.Item>
              )}
            </ListGroup>
          </Card.Body>
        </Card>
      </div>
      <div className="col-6 d-flex mt-3 pe-0">
        <Card className="border rounded d-flex mb-3" style={{width:"100%"}}>
          <Card.Body>
            <div className="d-flex justify-content-between" style={{marginBottom:"-8px", marginTop:"-10px"}}>
              <h4 style={{marginBottom:"-4px", marginTop:"3px"}}>Contacts</h4>
              {isLoading ? (
                <Spinner
                  className="align-self-center me-3"
                  {...{
                    as: 'span',
                    animation: 'border',
                    size: undefined,
                    role: 'status',
                    'aria-hidden': 'true',
                    variant: 'light',
                    style: {
                      height: '1.5rem',
                      width: '1.5rem',
                      marginBottom: '0.75rem'
                    }
                  }}
                />
              ) : (
                <ActionsDropdown variant="secondary" title="Actions">
                  <LoadingLink
                    href={"/" + organization + "/" + incident + "/people/owner/new?animal_id=" + id}
                    isLoading={isLoading}
                    className="d-block"
                    label="Add Owner To Animal"
                  >
                    <FontAwesomeIcon icon={faUserPlus} className="fas" inverse />
                  </LoadingLink>
                  <LoadingLink
                    isLoading={isLoading}
                    className="d-block"
                    onClick={() => {setShowContactNote(true)}}
                    label="Add Owner Contact Note"
                  >
                    <FontAwesomeIcon icon={faPhonePlus} className="fas" inverse />
                  </LoadingLink>
                </ActionsDropdown>
              )}
            </div>
          <p className="phr"/>
          <Scrollbar no_shadow="true" style={{height:"210px"}} renderThumbHorizontal={props => <div {...props} style={{...props.style, display: 'none'}} />}>
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
              {data.owners.map(owner => (
                <ListGroup.Item key={owner.id}><b>Owner: </b><Link href={"/" + organization + "/" + incident + "/people/owner/" + owner.id} className="text-link" style={{textDecoration:"none", color:"white"}}>{owner.first_name} {owner.last_name}</Link>
                {owner.display_phone ?
                  <span>&nbsp;{owner.display_phone}</span>
                  : ""}
                  {owner.email ?
                  <OverlayTrigger
                    key={"owner-email"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-owner-email`}>
                        {owner.email}
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faEnvelope} className="ms-1" inverse />
                  </OverlayTrigger>
                  : ""}
                  <OverlayTrigger
                    key={"remove-owner"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-remove-owner`}>
                        Remove owner
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={faMinusSquare} style={{cursor:'pointer'}} className="ms-1" onClick={() => {setOwnerToDelete({id:owner.id, name: owner.first_name + " " + owner.last_name});setShowOwnerConfirm(true);}} inverse />
                  </OverlayTrigger>
                </ListGroup.Item>
              ))}
              {data.reporter ?
              <ListGroup.Item><b>Reporter: </b><Link href={"/" + organization + "/" + incident + "/people/reporter/" + data.reporter} className="text-link" style={{textDecoration:"none", color:"white"}}>{data.reporter_object.first_name} {data.reporter_object.last_name}</Link></ListGroup.Item> : ""}
                {data.owners.length < 1 && !data.reporter ? <ListGroup.Item>No Contacts</ListGroup.Item> : ""}
                {data.owner_contacts.map(owner_contact => (
                <ListGroup.Item key={owner_contact.id}><b><Moment format="MMMM Do YYYY HH:mm">{owner_contact.owner_contact_time}</Moment></b>
                <OverlayTrigger
                    key={"add-contact-note"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-add-contact-note`}>
                        Update owner contact note
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon className="ms-1" onClick={() => {setNoteData({id: owner_contact.id, owner:owner_contact.owner, owner_contact_time:owner_contact.owner_contact_time, owner_contact_note:owner_contact.owner_contact_note });setShowContactNote(true)}} icon={faEdit} style={{cursor:"pointer"}} inverse />
                  </OverlayTrigger>
                  : {owner_contact.owner_contact_note}</ListGroup.Item>
                ))}
              </ListGroup>
            </Scrollbar>
          </Card.Body>
        </Card>
      </div>
    </div>
    <div className="col-12 d-flex mt-3 ps-0 pe-0">
      <Card className="border rounded" style={{width:"100%", height:"100%"}}>
        <Card.Body>
          <Card.Title>
            <h4>Description</h4>
          </Card.Title>
          <p className="phr"/>
          <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
            {data.color_notes ? <ListGroup.Item><b>Breed / Description:</b> {data.color_notes}</ListGroup.Item> : ""}
            {data.behavior_notes ? <ListGroup.Item style={{whiteSpace:"pre-line"}}><b>Animal Notes:</b> {data.behavior_notes}</ListGroup.Item> : ""}
            {data.medical_notes ? <ListGroup.Item style={{whiteSpace:"pre-line"}}><b>Medical Notes:</b> {data.medical_notes}</ListGroup.Item> : ""}
            {!data.color_notes && !data.behavior_notes && !data.medical_notes ? <ListGroup.Item>No description available</ListGroup.Item> : ""}
          </ListGroup>
        </Card.Body>
      </Card>
    </div>
    {data.medical_record ?
    <div className="row">
      <div className="col-6 d-flex mt-3" style={{marginRight:"-15px"}}>
        <Card className="border rounded" style={{width:"100%", height:"100%", marginBottom:"0px"}}>
          <Card.Body>
            <Card.Title>
              <h4>Medical
                {state.user.is_superuser || state.user.vet_perms ? <span className="float-end">
                  <OverlayTrigger
                    key={"medical-record"}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-medical-record`}>
                        View patient medical record.
                      </Tooltip>
                    }
                  >
                    <Link href={"/" + organization + "/" + incident + "/vet/medrecord/" + data.medical_record} style={{textDecoration:"none", color:"white"}}><FontAwesomeIcon icon={faFolderMedical} className="" inverse /></Link>
                  </OverlayTrigger>
                </span> : ""}
              </h4>
            </Card.Title>
            <p className="phr"/>
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
            {data.vet_requests.map(vet_request => (
              <ListGroup.Item key={vet_request.id}>
                <b>Vet Request:</b> <Link href={"/" + organization + "/" + incident + "/vet/vetrequest/" + vet_request.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>VR#{vet_request.id_for_incident}</Link> - {vet_request.status}
              </ListGroup.Item>
            ))}
            </ListGroup>
          </Card.Body>
        </Card>
      </div>
    </div>
    : ""}
    <History action_history={data.action_history} />
    <Modal show={publicShow} onHide={handlePublicClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Mark Animal {data.public ? 'Private' : 'Public'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {data.public ? 
            'Make this animal data and photo private and no longer viewable to the public?' :
            'Make this animal data and photo viewable to the public?'
          }
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handlePublicSubmit}>Yes</Button>
        <Button variant="secondary" onClick={handlePublicClose}>Close</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showChangeAnimalStatus} onHide={handleShowChangeAnimalStatusClose} dialogClassName="semi-wide-modal">
      <Modal.Header closeButton>
        <Modal.Title>Confirm Animal Status Change</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2">
          Change Status To:
        </div>
        <Select
          label="Change to"
          id="status"
          type="text"
          name="status"
          className="mb-3"
          options={changeStatusOptions}
          styles={customStyles}
          // isClearable={false}
          // ref={shelterRef}
          // key={`my_unique_shelter_select_key__${formikProps.values.shelter}`}
          onChange={(instance) => {
            setStatusChange(instance === null ? '' : instance.value);
          }}
          // value={formikProps.values.shelter||''}
        />
        {statusChange === 'return_requested' && !data.request ?
        <span>
          <p>
            Marking this animal as Return Requested will require the creation of a Service Request. Please choose a destination address to get started:
          </p>
          {data.owners.filter((v,i,a)=>a.findIndex(v2=>(v.full_address === v2.full_address))===i).map(owner => (
            <div key={owner.id} className="mt-1 mb-1" style={{height:"50px"}}>
              <div className="card-header rounded" style={{paddingLeft:"12px", height:"50px"}}>
                <MaterialRadio
                  id={String(owner.id)}
                  name={String(owner.id)}
                  type="checkbox"
                  className={classes.radio}
                  checked={selectedAddress.address === owner.full_address}
                  style={{
                    transform: "scale(1.25)",
                    marginLeft: "-9px",
                    marginTop: "-7px",
                    marginBottom: "-5px"
                  }}
                  sx={{
                    color: 'white', // Unchecked color
                    '&.Mui-checked': {
                      color: 'white', // Checked color
                    },
                  }}
                  onChange={(e) => {
                    setSelectedAddress({address:owner.full_address, string:'owner_id=' + owner.id + '&animal_id=' + data.id_for_incident + '&incident_id='+ state.incident.id})
                  }}
                  disableRipple
                  color="default"
                  slotProps={{ input: { 'aria-label': 'decorative radio' } }}
                />
                <label>{owner.full_address}</label>
              </div>
            </div>
          ))}
          <div className="mt-1 mb-1" style={{height:"50px"}}>
            <div className="card-header rounded" style={{paddingLeft:"12px", height:"50px"}}>
              <MaterialRadio
                id={'custom_address'}
                name={'custom_address'}
                type="checkbox"
                className={classes.radio}
                checked={selectedAddress.address === 'custom'}
                style={{
                  transform: "scale(1.25)",
                  marginLeft: "-9px",
                  marginTop: "-7px",
                  marginBottom: "-5px"
                }}
                sx={{
                  color: 'white', // Unchecked color
                  '&.Mui-checked': {
                    color: 'white', // Checked color
                  },
                }}
                onChange={(e) => {
                  setSelectedAddress({address:'custom', string:'animal_id=' + data.id_for_incident + '&incident_id='+ state.incident.id})
                }}
                disableRipple
                color="default"
                slotProps={{ input: { 'aria-label': 'decorative radio' } }}
              />
              <label>I would like to enter a custom address</label>
            </div>
          </div>
        </span> : statusChange === 'return_requested' && data.request ?
        <p style={{marginBottom:"-5px"}}>
          Marking this animal as Return Requested will use the existing Service Request for delivery at {data.request_address}.
          <br/>
          <div className="mt-2">Is this animal ready to be returned?</div>
        </p> : statusChange === 'reunited' ?
        <p style={{marginBottom:"-5px"}}>
          Has this animal been reunited with their owner?
        </p> :  statusChange === 'deceased' ?
        <p style={{marginBottom:"-5px"}}>
          Is this animal deceased?
        </p> : ""}
      </Modal.Body>
      <Modal.Footer>
        {statusChange === 'return_requested' && !data.request ?
          <Button variant="primary" onClick={() => {navigate('/' + organization + '/' + incident + '/hotline/workflow/return?' + selectedAddress.string)}} disabled={isLoading}>{isLoading ? "Sending..." : "Select"}</Button>
        : statusChange === 'return_requested' && data.request ?
          <Button variant="primary" onClick={() => {handleReturnRequestedSubmit()}} disabled={isLoading}>{isLoading ? "Updating..." : "Yes"}</Button>
        : statusChange.includes('REPORTED') ?
          <Button variant="primary" onClick={handleStatusChange}>Yes</Button>
        : statusChange === 'reunited' ?
          <Button variant="primary" onClick={handleReuniteSubmit}>Yes</Button>
        : statusChange === 'deceased' ?
        <Button variant="primary" onClick={handleDeceasedSubmit}>Yes</Button> : ""}
        <Button variant="secondary" onClick={handleShowChangeAnimalStatusClose}>Close</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={pllShow} onHide={handlePLLClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Mark Animal {data.pll_metadata ? 'Private' : 'Public'} on Petco Love Lost</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {data.pll_metadata ? 
            'Hide animal data and photo to no longer be displayed publicly on Petco Love Lost?' :
            'Send animal data and photo to be displayed publicly on Petco Love Lost?'
          }
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handlePLLSubmit} disabled={isLoading}>{isLoading ? "Sending..." : "Yes"}</Button>
        <Button variant="secondary" onClick={handlePLLClose}>Close</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showOwnerConfirm} onHide={handleOwnerClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Owner Removal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you would like to remove owner {ownerToDelete.name} from this animal?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleOwnerSubmit}>Yes</Button>
        <Button variant="secondary" onClick={handleOwnerClose}>Close</Button>
      </Modal.Footer>
    </Modal>
    <Formik
      initialValues={data}
      enableReinitialize={true}
      // validationSchema={Yup.object({
      // })}
      onSubmit={(values, { setSubmitting }) => {
        axios.patch('/animals/api/animal/' + data.id + '/', values)
        .then(response => {
          let updated_history = [...data.action_history];
          updated_history.unshift(state.user.first_name + " " + state.user.last_name + " sheltered animal in " + response.data.shelter_object.name + " 0 minutes ago.");
          if (response.data.room_name) {
            updated_history.unshift(state.user.first_name + " " + state.user.last_name + " roomed animal in " + response.data.room_name + " 0 minutes ago.");
          }
          setData(prevState => ({ ...prevState, shelter:response.data.shelter, shelter_object:response.data.shelter_object, room:response.data.room, room_name:response.data.room_name, action_history:updated_history}));
          setShowTransfer(false);
        })
        .catch(error => {
          setShowSystemError(true);
        });
      }}
    >
      {formikProps => (
      <Modal show={showTransfer} onHide={handleCloseTransfer}>
        <Modal.Header closeButton>
          <Modal.Title>Transfer Animal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="">
            <Col xs="12">
              <DropDown
                label="To Shelter / Room:"
                id="shelter"
                type="text"
                name="shelter"
                options={shelters.options}
                isClearable={false}
                // ref={shelterRef}
                key={`my_unique_shelter_select_key__${formikProps.values.shelter}`}
                onChange={(instance) => {
                  roomRef.current.clearValue();
                  formikProps.setFieldValue("room", '');
                  formikProps.setFieldValue("shelter", instance === null ? '' : instance.value);
                }}
                value={formikProps.values.shelter||''}
              />
            </Col>
          </Row>
          <Row className="mt-3 mb-3">
            <Col xs="12">
              <DropDown
                id="room"
                type="text"
                name="room"
                ref={roomRef}
                key={`my_unique_room_select_key__${formikProps.values.room}`}
                options={shelters.room_options[formikProps.values.shelter] ? shelters.room_options[formikProps.values.shelter] : []}
                isClearable={true}
                value={formikProps.values.room||''}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => {formikProps.submitForm();}}>Save</Button>
          <Button variant="secondary" onClick={handleCloseTransfer}>Close</Button>
        </Modal.Footer>
      </Modal>
      )}
    </Formik>
    <Formik
      initialValues={{'animal_count':data.animal_count, 'group_2':0, 'split_all':false}}
      enableReinitialize={true}
      validationSchema={Yup.object({
        animal_count: Yup.number(),
        group_2: Yup.number(),
        split_all: Yup.boolean(),
      })}
      onSubmit={(values, { setSubmitting }) => {
        axios.patch('/animals/api/animal/' + data.id + '/', values)
        .then(response => {
          setData(prevState => ({ ...prevState, animal_count:values.animal_count}));
          setShowSplit(false);
        })
        .catch(error => {
          setShowSystemError(true);
        });
      }}
    >
      {formikProps => (
      <Modal show={showSplit} onHide={handleCloseSplit}>
        <Modal.Header closeButton>
          <Modal.Title>Split Animal Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{textTransform:"capitalize"}}><b>Before Split: </b><span>{data.animal_count} {data.species_string}</span></div>
          <Row>
            <Col xs={2}>
              <div className="mt-3"><label className="mb-2"><b>Split All:</b></label></div>
              <Checkbox
                id={'split_all'}
                name={'split_all'}
                checked={formikProps.values.split_all}
                style={{
                  transform: "scale(1.50)",
                  marginLeft: "-5px",
                  marginTop: "-5px",
                  marginBottom: "-5px"
                }}
                onChange={() => {
                  if (!formikProps.values.split_all) {
                    formikProps.setFieldValue("animal_count", 1);
                    formikProps.setFieldValue("group_2", Number(data.animal_count) - 1)
                  }
                  else {
                    formikProps.setFieldValue("animal_count", data.animal_count);
                  }
                  formikProps.setFieldValue("split_all", !formikProps.values.split_all);
                }}
                disabled={Number(data.animal_count) > 10}
                disabled_text={"Cannot split animal groups larger than 10."}
              />
            </Col>
            <Col>
              {species.length && data.id ? <div className="mt-3"><b>Number of <span style={{textTransform:"capitalize"}}>{species.filter(specie_data => (specie_data.name.toLowerCase() === data.species_string_singular.toLowerCase()))[0].plural_name}</span> to Split: </b>{formikProps.values.group_2}</div> : ""}
              <OverlayTrigger
                key={"disabled"}
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-disabled`} hidden={!formikProps.values.split_all}>
                    Range slider may not be used with Split All
                  </Tooltip>
                }
              >
                <RangeSlider
                  value={formikProps.values.group_2}
                  onChange={(changeEvent) => {formikProps.setFieldValue("group_2", changeEvent.target.value);formikProps.setFieldValue("animal_count", data.animal_count - changeEvent.target.value);}}
                  min={0}
                  max={data.animal_count - 1}
                  className="mb-2 mt-2"
                  disabled={formikProps.values.split_all}
                />
              </OverlayTrigger>
            </Col>
          </Row>
          <div className="mt-2" style={{textTransform:"capitalize"}}><b>After Split:&nbsp;</b>{Number(formikProps.values.group_2) > 0 && !formikProps.values.split_all ? <span>{data.animal_count - Number(formikProps.values.group_2)}&nbsp;<span>{data.animal_count - Number(formikProps.values.group_2) === 1 && species.length > 0 && data.id ? species.filter(specie_data => specie_data.plural_name.toLowerCase() === data.species_string.toLowerCase())[0].name : data.species_string}</span>, {formikProps.values.group_2}&nbsp;<span>{Number(formikProps.values.group_2) === 1 && species.length > 0 && data.id ? species.filter(specie_data => specie_data.plural_name.toLowerCase() === data.species_string.toLowerCase())[0].name : data.species_string}</span></span> : formikProps.values.split_all ? Array(data.animal_count).fill("1 " + species.filter(specie_data => specie_data.plural_name.toLowerCase() === data.species_string.toLowerCase())[0].name).join(", ") : <span>{data.animal_count} {data.species_string}</span>}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => {formikProps.submitForm();}} disabled={Number(formikProps.values.group_2) === 0}>Split</Button>
          <Button variant="secondary" onClick={handleCloseSplit}>Close</Button>
        </Modal.Footer>
      </Modal>
      )}
    </Formik>
    <Formik
      initialValues={noteData}
      enableReinitialize={true}
      // validationSchema={Yup.object({
      // })}
      onSubmit={(values, { setSubmitting }) => {
        if (values.id) {
          axios.patch('/people/api/ownercontact/' + values.id + '/', values)
          .then(response => {
            let owner_contacts = [...data.owner_contacts]
            owner_contacts.filter(contact => contact.id === response.data.id)[0].owner = response.data.owner;
            owner_contacts.filter(contact => contact.id === response.data.id)[0].owner_contact_time = response.data.owner_contact_time;
            owner_contacts.filter(contact => contact.id === response.data.id)[0].owner_contact_note = response.data.owner_contact_note;
            setData(prevState => ({ ...prevState, owner_contacts:owner_contacts}));
            setNoteData({'id': null, 'owner':null, 'owner_contact_time': new Date(), 'owner_contact_note': ''})
            setShowContactNote(false);
          })
          .catch(error => {
            setShowSystemError(true);
          });
        }
        else {
          axios.post('/people/api/ownercontact/', values)
          .then(response => {
            setData(prevState => ({ ...prevState, owner_contacts:[...prevState.owner_contacts, response.data]}));
            setNoteData({'id': null, 'owner':null, 'owner_contact_time': new Date(), 'owner_contact_note': ''})
            setShowContactNote(false);
          })
          .catch(error => {
            setShowSystemError(true);
          });
        }
      }}
    >
      {formikProps => (
      <Modal show={showContactNote} onHide={handleCloseContactNote}>
        <Modal.Header closeButton>
          <Modal.Title>
            {formikProps.values.id ? "Update" : "Add"} Owner Contact Note
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="">
            <Col xs="12">
              <DropDown
                label="Owner*"
                id="owner"
                type="text"
                name="owner"
                options={data.owners.map(owner => ({value: owner.id, label: owner.first_name + ' ' + owner.last_name}))}
                isClearable={false}
                key={`my_unique_owner_select_key__${formikProps.values.owner}`}
                onChange={(instance) => {
                  formikProps.setFieldValue("owner", instance === null ? '' : instance.value);
                }}
                value={formikProps.values.owner||null}
              />
            </Col>
          </Row>
          <Row className="mt-3" style={{marginLeft:"-10px", marginRight:"-10px"}}>
            <Col>
              <DateTimePicker
                label="Owner Contact Time*"
                name="owner_contact_time"
                id="owner_contact_time"
                // xs="4"
                clearable={false}
                data-enable-time={true}
                onChange={(date, dateStr) => {
                  formikProps.setFieldValue("owner_contact_time", dateStr)
                }}
                value={formikProps.values.owner_contact_time||null}
                setFieldValue={formikProps.setFieldValue}
              />
            </Col>
          </Row>
          <Row className="mt-3 mb-3" style={{marginLeft:"-10px", marginRight:"-10px"}}>
            <Col classNAme="ps-0">
              <TextInput
                as="textarea"
                label="Owner Contact Note*"
                name="owner_contact_note"
                id="owner_contact_note"
                // xs="10"
                rows={5}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => {formikProps.submitForm();}}>Save</Button>
          <Button variant="secondary" onClick={handleCloseContactNote}>Close</Button>
        </Modal.Footer>
      </Modal>
      )}
    </Formik>
    <AnimalDeleteModal name={data.name} show={showAnimalConfirm} handleClose={handleAnimalClose} handleSubmit={handleAnimalSubmit} />
    </>
  );
};

export default AnimalDetails;
